import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';

const Sidebar = ({ isCollapsed, onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const name = cookies.get('name') || cookies.get('surname') || 'User';
    setUserName(name);
  }, []);

  const logout = () => {
    const cookieNames = [
      'auto_login_code', 'auth_key', 'access_token', 'name', 'email',
      'authenticated', 'user_type', 'user_id', 'surname'
    ];
    cookieNames.forEach(name => cookies.remove(name, { path: '/' }));
    window.location.href = 'https://cbthost.com';
  };

  const toggleMobileMenu = () => setMobileOpen(!mobileOpen);
  const navigateTo = (path) => { navigate(path); setMobileOpen(false); };

  // const menuItems = [
  //   { path: '/participate/dashboard', icon: 'fas fa-chalkboard-user', label: 'Dashboard' },
  //   { path: '/participate/preparena', icon: 'fas fa-brain', label: 'PrepArena' },
  //   { path: '/participate/profile', icon: 'fas fa-user-circle', label: 'Profile' },
  // ];

  const menuItems = [
  { path: '/participate/dashboard', icon: 'fas fa-chalkboard-user', label: 'Dashboard' },
  { path: '/participate/preparena', icon: 'fas fa-brain', label: 'PrepArena' },
  // { path: '/participate/smartgen', icon: 'fas fa-robot', label: 'SmartGen' },
  // { path: '/participate/ai-sets', icon: 'fas fa-list-ul', label: 'AI Sets' },
  { path: '/participate/ai-generator', icon: 'fas fa-cogs', label: 'AI Generator' },
  { path: '/participate/profile', icon: 'fas fa-user-circle', label: 'Profile' },
];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Mobile Header */}
      <nav className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white shadow-md border-b border-gray-200">
        <div className="flex items-center justify-between px-4 py-3">
          <button onClick={toggleMobileMenu} className="text-gray-700 focus:outline-none">
            <i className="fas fa-bars text-xl"></i>
          </button>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-bold">{userName.charAt(0).toUpperCase()}</span>
            </div>
            <span className="font-semibold text-gray-800">CBTHOST</span>
          </div>
          <div className="w-8"></div>
        </div>
      </nav>

      {/* Desktop Sidebar */}
      <div className={`hidden lg:flex flex-col fixed top-0 left-0 bottom-0 z-30 bg-white shadow-xl transition-all duration-300 ease-in-out ${isCollapsed ? 'w-20' : 'w-64'}`}>
        {/* Logo Area */}
        <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'justify-between'} p-4 border-b border-gray-100`}>
          {!isCollapsed && <h5 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">CBTHOST</h5>}
          <button onClick={onToggle} className="text-gray-500 hover:text-gray-700 focus:outline-none">
            <i className={`fas ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'} text-sm`}></i>
          </button>
        </div>

        {/* User Profile Summary */}
        {!isCollapsed && (
          <div className="flex items-center gap-3 p-4 border-b border-gray-100">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-white font-semibold">{userName.charAt(0).toUpperCase()}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-800 truncate">{userName}</p>
              <p className="text-xs text-gray-500 truncate">Student</p>
            </div>
          </div>
        )}

        {/* Navigation Menu */}
        <div className="flex-1 overflow-y-auto py-4 px-3">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => navigateTo(item.path)}
              className={`flex items-center w-full px-3 py-3 mb-1 rounded-xl transition-all duration-200 group ${
                isActive(item.path)
                  ? 'bg-gradient-to-r from-blue-50 to-purple-50 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <i className={`${item.icon} text-lg ${isCollapsed ? '' : 'mr-3'} ${isActive(item.path) ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'}`}></i>
              {!isCollapsed && <span className="text-sm font-medium">{item.label}</span>}
            </button>
          ))}
        </div>

        {/* Logout Button */}
        <div className="p-3 border-t border-gray-100">
          <button
            onClick={logout}
            className={`flex items-center w-full px-3 py-3 rounded-xl text-red-600 hover:bg-red-50 transition-all duration-200 ${isCollapsed ? 'justify-center' : ''}`}
          >
            <i className="fas fa-sign-out-alt text-lg"></i>
            {!isCollapsed && <span className="ml-3 text-sm font-medium">Logout</span>}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div className={`fixed inset-0 z-50 transition-opacity duration-300 lg:hidden ${mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        <div className="absolute inset-0 bg-black bg-opacity-50" onClick={toggleMobileMenu}></div>
        <div className={`absolute top-0 left-0 bottom-0 w-72 bg-white shadow-2xl transform transition-transform duration-300 flex flex-col ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <div className="flex justify-between items-center p-4 border-b border-gray-100">
            <h5 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">CBTHOST</h5>
            <button onClick={toggleMobileMenu} className="text-gray-500">
              <i className="fas fa-times text-lg"></i>
            </button>
          </div>
          <div className="flex items-center gap-3 p-4 border-b border-gray-100">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-white font-semibold">{userName.charAt(0).toUpperCase()}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-800">{userName}</p>
              <p className="text-xs text-gray-500">Student</p>
            </div>
          </div>
          <div className="flex-1 overflow-y-auto py-4 px-3">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={() => navigateTo(item.path)}
                className={`flex items-center w-full px-3 py-3 mb-1 rounded-xl transition-all ${
                  isActive(item.path) ? 'bg-gradient-to-r from-blue-50 to-purple-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                <i className={`${item.icon} text-lg mr-3`}></i>
                <span className="text-sm font-medium">{item.label}</span>
              </button>
            ))}
            <button onClick={logout} className="flex items-center w-full px-3 py-3 rounded-xl text-red-600 hover:bg-red-50 mt-2">
              <i className="fas fa-sign-out-alt text-lg mr-3"></i>
              <span className="text-sm font-medium">Logout</span>
            </button>
          </div>
          <div className="p-4 text-center border-t border-gray-100">
            <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} CBTHOST.COM</p>
          </div>
        </div>
      </div>
    </>
  );
};

export { Sidebar };